import { LocationStoreType } from '@/features/listing/listing.types';
import { useOasApp } from '@/providers';
import { SearchAddressData } from '@/types/SearchAddressData';

export const getSearchAddressData = (searchAddressData: SearchAddressData): LocationStoreType => {
  if (searchAddressData && searchAddressData.results && searchAddressData.results.length > 0) {
    const firstResult = searchAddressData.results[0];

    const selectedLocationFromSession =
      typeof window !== 'undefined' ? sessionStorage.getItem('selectedLocation') : null;

    let parsedSelectedLocation = null;
    if (selectedLocationFromSession) {
      try {
        parsedSelectedLocation = JSON.parse(selectedLocationFromSession);
      } catch (e) {
        console.log("Couldn't parse selectedLocation JSON from session", e);
        parsedSelectedLocation = null;
      }
    }

    // If the first result from searchAddressData matches the selected location from session,
    // we prioritize the session storage data to maintain consistency with user selection.
    if (firstResult?.address?.postalCode === parsedSelectedLocation?.zipCode) {
      return {
        zip: parsedSelectedLocation?.zipCode || '',
        latitude: parsedSelectedLocation?.latitude
          ? parseFloat(parsedSelectedLocation.latitude)
          : null,
        longitude: parsedSelectedLocation?.longitude
          ? parseFloat(parsedSelectedLocation.longitude)
          : null,
        address: parsedSelectedLocation?.address || '',
      };
    }

    return {
      zip: firstResult?.address?.postalCode || '',
      latitude: firstResult?.position?.lat || null,
      longitude: firstResult?.position?.lon || null,
      address: firstResult?.address?.freeformAddress || '',
    };
  }
  return null;
};

export const usePagePropsAddressData = (): ReturnType<typeof getSearchAddressData> | undefined => {
  const fields = useOasApp();
  const { searchAddressData } = fields;

  if (!searchAddressData) {
    return undefined;
  }

  return getSearchAddressData(searchAddressData as SearchAddressData);
};
